import script from "./AddSingleProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./AddSingleProduct.vue?vue&type=script&setup=true&lang=js"

import "./AddSingleProduct.vue?vue&type=style&index=0&id=2f4d9193&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f4d9193"]])

export default __exports__